import classes from "./ProductHeroQuantityInput.module.scss";

const ProductHeroQuantityInput = ({
  onIncrease,
  onDecrease,
  value,
  onChange,
  availableForSale,
}) => {
  return (
    <div className={classes["product-hero-quantity-button"]}>
      {availableForSale && (
        <div className={classes["product-hero-quantity-button__quantity"]}>
          <button
            className={
              classes["product-hero-quantity-button__quantity__button"]
            }
            onClick={onDecrease}
          >
            -
          </button>
          <input
            type="number"
            className={classes["product-hero-quantity-button__quantity__input"]}
            value={value}
            onChange={onChange}
            aria-label="Product quantity"
            readOnly
          />
          <button
            className={
              classes["product-hero-quantity-button__quantity__button"]
            }
            aria-label="Increase quantity"
            onClick={onIncrease}
          >
            +
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductHeroQuantityInput;
